import type { FeatureRoute } from '../types';
import { PaymentDetailPage } from './PaymentDetailPage';
import { PaymentFormPage } from './PaymentFormPage';
import { PaymentPrintPage } from './PaymentPrintPage';
import { PaymentsPage } from './PaymentsPage';

/** Routes owned by this feature (paths are relative to the app root, e.g. 'customers/:id'). */
export const routes: FeatureRoute[] = [
  { path: 'payments', element: <PaymentsPage /> },
  { path: 'payments/new', element: <PaymentFormPage /> },
  { path: 'payments/:id', element: <PaymentDetailPage /> },
  { path: 'payments/:id/print', element: <PaymentPrintPage /> },
];
